import { render, staticRenderFns } from "./output-frame.vue?vue&type=template&id=1bdb7ae4&scoped=true&"
import script from "./output-frame.vue?vue&type=script&lang=js&"
export * from "./output-frame.vue?vue&type=script&lang=js&"
import style0 from "./output-frame.vue?vue&type=style&index=0&id=1bdb7ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdb7ae4",
  null
  
)

export default component.exports